// src/components/shared/UnreadCount.js
import React from "react";
import PropTypes from "prop-types";

const UnreadCount = ({ count }) => {
  if (!count || count <= 0) return null;
  return (
    <div className="unread-count">
      {count > 99 ? "99+" : count}
    </div>
  );
};

UnreadCount.propTypes = {
  count: PropTypes.number,
};

export default UnreadCount;
